<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img :src="getFileServerUrl + order?.branch?.company?.logo" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="order?.branch?.company?.header_image">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!order?.branch?.company?.header_image">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ order.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ order.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ order.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ order.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">Purchase Report</h2>
                      </div>
                    </td>
                  </tr>
                  

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%" >
                      <div class="master-box mt-4" style="font-size: 13px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>INVOICE DATE</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(order.invoice_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>SEASON</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.season || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Shipment Date</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(order.shipment_date) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>SALES CONTACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.contact_no }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>MASTER SALES CONTACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.master_sales_contact_no || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>PURCHASE ORDER (PO) NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.purchase_order_no }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 8px;">
                              <strong>SUPPLIER / BENEFICIARY:</strong><br/>
                              {{ order.buyer?.company_name || '-' }}<br/>
                              {{ order.buyer?.company_address || '-' }}<br/>
                              Email: {{ order.buyer?.company_email || '-' }}<br/>
                              Phone: {{ order.buyer?.company_mobile || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 8px;">
                              <strong>BUYER:</strong><br/>
                              {{ order.buyer?.company_name || '-' }}<br/>
                              {{ order.buyer?.company_address || '-' }}<br/>
                              Email: {{ order.buyer?.company_email || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 8px;">
                              <strong>Style Beaufort:</strong><br/>
                              Color - : {{ getColorString() }}<br/>
                              Total Qty - : {{ totalQty() }}PCS<br/>
                              Total Value - USD : {{ totalValue() }}<br/>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 8px;">
                              <strong>Shipment Mode:</strong><br/>
                              {{ order.shipping_method?.name || '-' }}<br/>
                              Shipment From: {{ order.from_shipment || '-' }}<br/>
                              Shipment To: {{ order.to_shipment || '-' }}<br/>
                              Early Shipment - {{ (order.early_shipment || '-').toUpperCase() }}<br/>
                              Transhipment - {{ (order.transhipment || '-').toUpperCase() }}<br/>
                              Short Excess Tolerance - {{ (order.short_excess_tolerance || '0') + '%+/-' }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details Table Row -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="dep-table order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 8px;">SL</th>
                            <th style="border: 1px solid #000; padding: 8px;">Color</th>
                            <th v-for="(size, si) in order.bindings?.sizes" :key="si" style="border: 1px solid #000; padding: 8px;">{{ size }}</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 8px;">Colour Qty</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Unit Price</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Total Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(color, ci) in order.bindings?.colors" :key="ci">
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">{{ ci + 1 }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ color || '-' }}</td>
                            <td v-for="(size, si) in order.bindings?.sizes" :key="si" class="text-center" style="border: 1px solid #000; padding: 8px;">
                              {{ order.bindings.breakdown[color]?.[size]?.quantity || 0 }}
                            </td>
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">{{ totalColorQty(color) }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">
                              {{ order.bindings.breakdown[color]?.[order.bindings?.sizes[0]??null]?.unit_price || 0 }}
                            </td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ totalColorValue(color) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <img v-if="order?.branch?.company?.footer_image" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;">
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="center" class="d-print-none mt-4">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print">
        Print
      </v-btn>
    </v-row>

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const order = ref({
  branch: {},
  production: {},
  bindings: {
    breakdown: {},
    colors: [],
    sizes: []
  }
});

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-GB");
}

async function fetchDetails(id) {
  const res = await store.dispatch("getBhpPurchaseOrderById", { id });
  const data = res.data.data;

  const breakdown = data.bindings.breakdown || {};
  const colors = data.bindings.colors || [];
  const sizes = data.bindings.sizes || [];

  colors.forEach(color => {
    sizes.forEach(size => {
      if (!breakdown[color][size]) {
        breakdown[color][size] = { quantity: 0, unit_price: 0 };
      }
    });
  });

  order.value = {
    ...data,
    bindings: {
      breakdown,
      colors,
      sizes
    }
  };
}

function getColorString() {
  const colors = order.value.bindings.colors || [];
  const colorArray = Array.isArray(colors) ? colors : Object.values(colors);
  const formattedColors = colorArray.map(c => c.charAt(0).toUpperCase() + c.slice(1));
  return formattedColors.join(', ');
}

function totalQty(color) {
  var total = 0
  const colors = order.value.bindings.colors || [];
  colors.forEach(color => {
    total += totalColorQty(color);
  });

  return total;
}

function totalValue(color) {
  var total = 0
  const colors = order.value.bindings.colors || [];
  colors.forEach(color => {
    total += totalColorValue(color);
  });

  return total;
}


function totalColorQty(color) {
  const breakdown = order.value.bindings.breakdown[color] || {};
  const sizes = order.value.bindings.sizes || [];
  let total = 0;
  sizes.forEach(size => {
    total += breakdown[size]?.quantity || 0;
  });
  return total;
};

function totalColorValue(color){
  const breakdown = order.value.bindings.breakdown[color] || {};
  const sizes = order.value.bindings.sizes || [];
  const unitPrice = order?.value?.bindings.breakdown[color]?.[order?.value?.bindings?.sizes[0]??null]?.unit_price || 0;
  return totalColorQty(color) * unitPrice;
}

function print() {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Purchase Report</title>
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          @page {
            size: A4;
            margin: 0;
            padding: 0;
          }

          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
          }

          body { 
            font-family:"Times New Roman", serif; 
            background:#fff; 
            color:#000; 
            -webkit-print-color-adjust: exact; 
            print-color-adjust: exact;
          }

          .report-paper { 
            width: 100%; 
            padding: 0;
            background: #fff;
            position: ;
          }

          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }

          header img {
            width: 100%;
            display: block;
            margin: 0;
            padding: 0;
          }

          main { 
            position: relative;
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
            page-break-after: avoid;
          }

          main > * {
            page-break-inside: avoid;
          }

          footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            z-index: 10;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          footer img {
            width: 100%;
            display: block;
            margin: 0;
            padding: 0;
          }

          .page-header {
            margin-top:250px;
            margin-bottom: 20px;
          }

          .header-section { 
            display: flex; 
            justify-content: space-between; 
            align-items: flex-start; 
            border-bottom: 2px solid #eee; 
            padding-bottom: 10px; 
            margin-bottom: 16px; 
          }

          .company-name { 
            font-size: 20px; 
            font-weight: bold; 
            text-transform: uppercase; 
            margin: 0 0 4px 0; 
          }

          .company-text { 
            font-size: 14px; 
            margin: 2px 0; 
            display: flex; 
            align-items: center; 
          }

          .logo-container img { 
            max-height: 70px; 
            max-width: 150px; 
          }

          .report-title { 
            font-size: 20px; 
            text-align: center; 
            margin: 16px 0; 
          }

          .master-box {
            margin-top: 16px;
            margin-bottom: 16px;
            font-size: 13px;
          }

          table { 
            width: 100%; 
            border-collapse: collapse; 
            font-size: 13px; 
            margin-bottom: 24px;
            background: white;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          th, td { 
            border: 1px solid #000; 
            padding: 6px; 
            vertical-align: middle; 
          }

          th { 
            background: #e0e0e0; 
            text-align: center; 
            font-weight: bold;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .master-box-parent {
            border: none;
          }

          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .mt-4 { margin-top: 16px !important; }
          .my-6 { margin-top: 24px !important; margin-bottom: 24px !important; }

          img { 
            max-width: 100% !important; 
            height: auto !important; 
          }

          .d-flex { display: flex; }
          .justify-space-between { justify-content: space-between; }
          .align-start { align-items: flex-start; }
          .v-row { 
            display: flex !important; 
            flex-wrap: wrap !important; 
            margin: 0 -12px;
          }

          .v-col-6 { 
            flex: 0 0 50% !important; 
            max-width: 50% !important; 
            padding: 12px;
            box-sizing: border-box;
          }

          .pa-6 { padding: 0 !important; }

          .order-table thead {
            display: table-header-group;
          }

          .order-table tbody tr {
            page-break-inside: avoid;
          }

          @media print { 
            body {
              margin: 0;
              padding: 0;
            }

            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 0;
            }

            .report-paper {
              margin: 0;
              padding: 0;
            }

            main {
              padding-top: 180px;
              padding-bottom: 150px;
              padding-left: 20px;
              padding-right: 20px;
            }
            .invoice-container {
              display: flex;
              flex-direction: column;
              // height: 100vh;
              // page-break-after: always;
            }

            .invoice-content {
              flex: 1;
              overflow: hidden;
            }

            .invoice-footer {
              // flex-shrink: 0;
              margin-top: auto;
              position: fixed;
              left; 0;
              bottom: 15px;
              width: 100%;              
              // page-break-inside: avoid;
            }
            

            // table {
            //   page-break-inside: avoid;
            // }
            
            // tr {
            //   page-break-inside: avoid;
            // }
  
            .order-table {
              page-break-inside: auto;
            }

            .order-table tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            .order-table thead {
              display: table-header-group;
            }
          }
        </style>
        </head>
        <body>
          ${printContent}
        </body>
        </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
}

onMounted(() => {
  fetchDetails(route.params.id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 20px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 14px; }
.report-title { font-size: 20px; text-align: center; margin: 16px 0; }
.meta-box { border: 1px solid #000; padding: 8px; font-size: 13px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 6px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

</style>